import dynamic from 'next/dynamic';
import { RfpHeaderProps } from './RfpHeader.types';

export const RfpHeader = dynamic<{ model: RfpHeaderProps }>(() => import('./RfpHeader').then(mod => mod.RfpHeader));
